<template>
  <div id="device_tab"
       class="main-tab main-tab-o">
    <div class="dv-reds-top">
      <img src="../assets/images/icon_no_bg.png"
           class="img-reds-bg">
      <div class="dv-content-reds">
        <div class="dv-rou-content">
          <router-link class="tv-routor"
                       to='/'>首页</router-link>
          <div class="tv-routor">/</div>
          <router-link class="tv-routor"
                       to='/notice'>院内公告</router-link>
          <div class="tv-routor">/</div>
          <router-link class="tv-routor"
                       to=''>详情</router-link>
        </div>
        <div class="dv-reds-item-bg">
          <div class="dv-reds-title">{{ info.title }}</div>
          <div class="dv-reds-content"
               v-html="info.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api/api'
const aes = require('../utils/aes.js')
export default {

  data () {
    return {
      info: ''
    }
  },
  created () {
    // this.fid = this.$route.query.fid
    this.recruitdetail(this.$route.query.id)
  },
  methods: {
    //荣誉资质列表
    recruitdetail (newsid) {
      let parm = {
        FKEY: api.getFKEY(),
        newsid: aes.Encrypt(newsid)

      }
      api.recruitdetail(parm).then((res) => {
        this.info = res.data

      })
    },
  }

}
</script>

<style>
.dv-reds-top {
  width: 100%;
  height: fit-content;
  position: relative;
  display: flex;
  /* margin-top: 40px; */
  flex-direction: column;
}
.img-reds-bg {
  width: 100%;
  position: absolute;
  /* top: 40px; */
}
.dv-content-reds {
  width: calc(100% - 600px);
  margin-left: 300px;
  min-height: 800px;
  /* margin-top: 40px; */
  display: flex;
  flex-direction: column;
  text-align: left;
}
.tv-routor {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #8271ae;
  margin-top: 20px;
}
.dv-rou-content {
  display: flex;
  flex-direction: row;
}
.dv-reds-item-bg {
  width: 100%;
  min-height: 500px;
  background: white;
  margin-top: 200px;
  margin-bottom: 100px;
  border: 2px solid #eef0f5;
  display: flex;
  flex-direction: column;
}
.dv-reds-title {
  margin: 22px;
  font-size: 18px;
  color: #333333;
}
.dv-reds-content {
  width: calc(100% - 40px);
  margin-left: 20px;
}
</style>